import axios from 'axios';
import { logger } from '@fiverr-private/perseus';

const fetchReviewAsync = async({ orderId, pathfinderWrapper }) => {
    try {
        const ajaxUrl = pathfinderWrapper.pathfinder('gig_page_order_review', { id: orderId });
        const { data } = await axios.get(ajaxUrl);
        return data;
    } catch (error) {
        logger.error(error, { description: 'Error while fetching review', orderId });
        return null;
    }
};

export default fetchReviewAsync;
